module.exports = __webpack_public_path__ + "img/36600.45e323a5.jpg";